import { ArianeElement, ArianeStore, NotificationService, WaitingModalService, UserStore, ModalService } from '@digicerba/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  SaveInstanceModeleFormulaireDto, InstanceModeleFormulaireDto,
  IInstanceModeleFormulaireWebServiceClient
} from '@resources/resources';
import { AsiFileService } from '@asi-ngtools/lib';
import { environment } from 'environments/environment';
import { PDFService } from '../../../../common/services/pdf.service';
import { find } from 'lodash';

@Component({
  selector: 'formulaire-demat',
  templateUrl: './formulaires.html',
  host: { 'class': 'page' }
})
export class FormulaireDematComponent implements OnInit {
  pending: boolean;
  printElement: HTMLElement;
  cacheWidth: number;
  htmlContent = 'Chargement ...';
  isUpdate: boolean;
  isTermine: boolean;
  formulaire: SaveInstanceModeleFormulaireDto = new SaveInstanceModeleFormulaireDto();
  isIframe: boolean;

  constructor(private notificationService: NotificationService, private router: Router, private userStore: UserStore, private fileUtils: AsiFileService, arianeStore: ArianeStore,
    private route: ActivatedRoute, private instanceModeleFormulaireWebServiceClient: IInstanceModeleFormulaireWebServiceClient, private modalService: ModalService,
    private waitingModal: WaitingModalService, private pdfService: PDFService) {


    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: 'Dossiers bloqués',
        route: ''
      },
      {
        libelle: 'Formulaire',
        route: '/formulaire'
      }
    ];


    arianeStore.updateElements(arianeElements);
  }

  ngOnInit() {

    this.initFormulaire();

    this.fileUtils.getFileAsText(environment.contextPath + 'api/document/' + this.formulaire.instance.idModeleFormulaire).subscribe((file) => {
      this.htmlContent = file;

      // Il y a des données à charger
      // Le renderer d'Angular est fait après
      let checkExist = setInterval(() => {
        if (document.getElementById('print-section').getElementsByTagName('*').length > 0) {
          this.fillForm();
          clearInterval(checkExist);
        }
      });
    });
    this.isIframe = false;
    if(this.router && this.router.url){
      let baseUrl = this.router.parseUrl(this.router.url)
      if(baseUrl && baseUrl.queryParams && baseUrl.queryParams["isIframe"] === "true"){
        this.isIframe = true;
      }
    }
  }

  initFormulaire(): void {
    let formulaire = this.route.snapshot.data['formulaire'];

    if (formulaire != null) {
      this.formulaire = formulaire;
      this.isUpdate = true;
      this.isTermine = this.formulaire.instance.status === 'TERMINE' || !this.formulaire.instance.modifiable;

    } else {
      this.formulaire.instance = new InstanceModeleFormulaireDto();
      this.formulaire.valeurs = [];
      this.formulaire.instance.idUser = +this.userStore.getUser().id;
      this.formulaire.instance.idModeleFormulaire = this.route.snapshot.params['id'];
    }
  }

  fillForm(): void {
    const printElement = document.getElementById('print-section');
    const elements = printElement.getElementsByTagName('*');
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      if (element instanceof HTMLInputElement) {
        const input: HTMLInputElement = element;
        input.disabled = this.isTermine;
        if (input.id.startsWith('formulairedemat_')) {
          let valeurInstance = this.formulaire.valeurs.find(elt => {
            return elt.cle === input.id.replace('formulairedemat_', '');
          });
          if (valeurInstance != null) {
            input.type === 'checkbox' ? input.checked = valeurInstance.valeur == 'true' : input.value = valeurInstance.valeur;
          }
        }
      }
    }
    const printOnly = document.getElementsByClassName('print-only');
    for (let i = 0; i < printOnly.length; i++) {
      const element = printOnly[i];
      if (element instanceof HTMLElement ) {
        element.style.visibility = 'hidden';
      }
    }
  }

  save(status: string): void{
    this.modalService.openConfirmDialog("MODAL.VALIDATE.titre","MODAL.VALIDATE.question","MODAL.CONFIRM.confirm","MODAL.CONFIRM.cancel")
    .onDialogClose().subscribe(() => {
      this.doSave(status);
    })
  }

  doSave(status: string): void {
    this.waitingModal.openModal();
    // création d'une instance
    const printElement = document.getElementById('print-section');
    const elements = printElement.getElementsByTagName('*');
    this.pending = true;
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      if (element instanceof HTMLInputElement) {
        const input: HTMLInputElement = element;
        if (input.id.startsWith('formulairedemat_')) {
          // TODO : check si value vide
          let id = input.id.replace('formulairedemat_', '');
          let valeur = find(this.formulaire.valeurs, function (v) {
            return v.cle === id;
          });

          if (valeur) {
            valeur.valeur = (input.type === 'checkbox' ? input.checked + "" : input.value);
            valeur.idInstanceModele = this.formulaire.instance.id;
          } else {
            this.formulaire.valeurs.push({
              cle: id,
              valeur: (input.type === 'checkbox' ? input.checked + "" : input.value),
              idInstanceModele: this.formulaire.instance.id
            });
          }
        }
      }
    }
    this.formulaire.instance.status = status;

    if (this.isUpdate) {
      this.instanceModeleFormulaireWebServiceClient.modifierInstanceModeleFormulaire(this.formulaire).subscribe(() => {
        this.router.navigate(['']);
      },
        () => {
          this.pending = false;
          this.notificationService.showErrorNotification("ERRORS.unprocessable");
        });
    } else {
      this.instanceModeleFormulaireWebServiceClient.saveInstanceModeleFormulaire(this.formulaire).subscribe(() => {
        this.router.navigate(['']);
      },
        () => {
          this.pending = false;
          this.notificationService.showErrorNotification("ERRORS.unprocessable");
        });
    }
    this.waitingModal.closeModal();
  }

  /*************************************************************************************
   *************************************IMPRESSION**************************************
   *************************************************************************************/

  async print() {

    this.pending = true;

    const printElement = document.getElementById('formulairedemat');
    let orientation = 'portrait';
    let multipage = false;

    for (let i = 0; i < printElement.attributes.length; i++) {
      const attribute = printElement.attributes.item(i);
      if (attribute.name === 'orientation') {
        orientation = attribute.value;
      } else if (attribute.name === "multipage") {
        multipage = true;
      }
    }

    const margin = 20;
    const pdf = this.pdfService.createPDF(orientation, 'pt', 'a4');
    const pdfWidth = this.pdfService.getPDFWidth(pdf, margin);

    this.waitingModal.openModal();

    await this.pdfService.printDiv(pdf, printElement as HTMLElement, margin, pdfWidth, multipage);

    this.waitingModal.closeModal();
    this.pdfService.save(pdf, 'HTML-Document.pdf');
    this.pending = false;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/pages/formulaires/formulaires.ts